module.exports = __webpack_public_path__ + "static/media/ice6.712700d6.webp";